<template>
  <div v-if="user" class="dataset-card-page col-block width-full" :class="[layoutType, { disabled: ['created', 'failed'].includes(dataset.state) || dataset.disabled, archived: dataset.dataset_config.archived }]" @click.stop="e => cardOnClick()">
    <div :style="{ height: '20px' }"></div>
    <div class="card-title-container row-block flex-start">
      <div class="card-title-block row-block flex-start" :style="{ flex: 1 }">
        <div :style="{ width: '20px' }"></div>
        <div class="card-title" :style="{ flex: 1 }">{{ subCharString(dataset.name, (['community', 'share'].includes(type) ? 60 : 75)) + (getCharLength(dataset.name) > (['community', 'share'].includes(type) ? 60 : 75) ? '...' : '') }}</div>
      </div>
      <div v-if="['community', 'share'].includes(type)" class="card-picture-field row-block flex-start">
        <div class="card-picture-container col-block flex-end" :style="{ width: '116px' }">
          <div :style="{ flex: 1 }"></div>
          <div class="card-picture-block col-block width-full">
            <div class="card-picture" :style="{ 'background-image': 'url(' + (getPictureUrl(dataset.dataset_picture_file) || require('../../assets/images/user-avatar.svg')) + ')' }"></div>
          </div>
        </div>
        <div :style="{ width: '20px' }"></div>
      </div>
      <div v-else class="card-option-container col-block" :style="{ width: '40px' }">
        <div class="icon-list col-block">
          <div v-if="['supervisor'].includes(user.role) && dataset.as_admin_annotation" class="annotation-icon admin icon-block" :title="''/* ___ */" :style="{ '--size': '40px' }">
            <datasetAnnotationAdminSolid
              :color="'#F8C600'"
            ></datasetAnnotationAdminSolid>
          </div>
          <div v-if="(dataset.as_private_annotation || dataset.as_external_annotation) && (dataset.user || {}).email === user.email" class="annotation-icon icon-block" :style="{ '--size': '40px' }">
            <borCor
              :reverse="true"
              :background="'white'"
              :border="'#CCCCCC'"
              :radius="'0px'"
              :blockStyle="{
                padding: '10px'
              }"
            >
              <div slot="trigger">
                <datasetAnnotationSolid
                  :color="dataset.as_private_annotation ? '#003679' : dataset.as_external_annotation ? '#349CCF' : 'transparent'"
                ></datasetAnnotationSolid>
              </div>
              <div slot="content">
                <div
                  v-html="(dataset.as_private_annotation ? [
                    'The dataset with all your data',
                    'is selected for annotation.'
                  ]/* ___ */
                  : dataset.as_external_annotation ? [
                    'The dataset with community data',
                    'is selected for annotation.'
                  ]/* ___ */
                  : []).join('<br>')"
                ></div>
              </div>
            </borCor>
          </div>
        </div>
        <div class="status-icon icon-block" :style="{ '--size': '40px', cursor: 'default' }">
          <img :src="(['created', 'failed'].includes(dataset.state) || dataset.disabled) ? require('../../assets/images/dataset-status-disabled.svg') : require('../../assets/images/dataset-status-enabled.svg')" alt="">
        </div>
      </div>
    </div>
    <div class="card-main-container col-block width-full">
      <div class="card-information-list-container row-block flex-start flex-wrap">
        <div class="card-information-container col-block width-full" v-for="(option, index) in informationOptions" :key="index" :style="{ width: '33.33%' }">
          <div class="card-information-block col-block flex-start">
            <div class="card-information-title">{{ option.title }}</div>
            <div class="card-information-content" v-html="option.value(dataset)"></div>
          </div>
        </div>
      </div>
      <div class="card-description-container">
        <div class="card-description-block col-block flex-start">
          <div class="card-description-title">{{ 'Description'/*___ */ }}</div>
          <div class="card-description-content">{{ dataset.description ? subCharString(dataset.description, 240) + (getCharLength(dataset.description) > 240 ? '...' : '') : '- -' }}</div>
        </div>
      </div>
      <div v-if="['community'].includes(type)" class="card-owner-main-container row-block flex-start">
        <div class="card-owner-container" :style="{ flex: 1 }">
          <div class="card-owner-block col-block flex-start">
            <div class="card-owner-title">{{ 'Owner'/*___ */ }}</div>
            <div
              class="card-owner-content"
              v-html="[
                [dataset.user.first_name, dataset.user.last_name].filter(x => x).join(' ') + (dataset.user.organization || dataset.user.division ? ' (' + [dataset.user.organization, dataset.user.division].filter(x => x).join(' ') + ')' : ''),
                dataset.user.email
              ].join('\n')"
            ></div>
          </div>
        </div>
        <div class="card-owner-avatar" :style="{ 'background-image': 'url(' + (getPictureUrl(dataset.user.avatar) || require('../../assets/images/user-avatar.svg')) + ')' }"></div>
      </div>
      <div v-if="dataset.tags.length" class="card-tag-container" :class="{ collapsable: ['default'].includes(layoutType) && ![null, undefined].includes(collapse), collapse: ['default'].includes(layoutType) && collapse }">
        <div class="card-tag-block col-block flex-start">
          <div class="card-tag-title-container row-block">
            <a class="card-tag-title-block row-block" @click.stop="e => ['default'].includes(layoutType) && (collapse = { true: false, false: true }[collapse + ''])">
              <div class="card-tag-title">{{ 'Tags'/*___ */ }}</div>
              <div :style="{ width: '5px' }"></div>
              <div class="card-tag-collapse-icon icon-block" :style="{ '--size': '20px' }">
                <img :src="require('../../assets/images/tags-arrow-up.svg')" alt="">
              </div>
            </a>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="card-tag-list-container width-full">
            <div ref="tag-list" class="card-tag-list-block row-block flex-start flex-wrap">
              <div class="card-tag-block row-block" :title="tag" v-for="(tag, index) in dataset.tags" :key="index">
                <div class="card-tag-title">{{ tag }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ flex: 1 }"></div>
    <div :style="{ height: '20px' }"></div>
  </div>
</template>

<script>
import { API_ROOT } from '../../api/config'
import borCor from '../tool/newBorCor.vue'
import datasetAnnotationSolid from '../../components/svg/dataset-annotation-solid.vue'
import datasetAnnotationAdminSolid from '../../components/svg/dataset-annotation-admin-solid.vue'
import toastMethods from '../../mixins/toastMethods.vue'
import { datasetStatusMap, datasetPermissionMap, datasetPipelineMap } from '../../constants/global/data'
import { toPriceString, dateFormat, getCharLength, subCharString } from '../../constants/global/util'
import { mapGetters } from 'vuex'

export default {
  components: {
    borCor,
    // svg
    datasetAnnotationSolid,
    datasetAnnotationAdminSolid
  },
  mixins: [
    toastMethods
  ],
  props: {
    type: {
      type: String,
      default: () => 'default'
    },
    dataset: {
      type: Object,
      required: true
    },
    layoutType: {
      type: String,
      default: () => 'default'
    }
  },
  data () {
    return {
      collapse: null
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    // static
    informationOptions () {
      return ['community', 'share'].includes(this.type) ? [
        {
          title: 'Create',
          value: dataset => dateFormat(new Date(dataset.created_at), 'yyyy/MM/dd hh:mm')
        },
        {
          title: 'Permission',
          value: dataset => {
            let permission = datasetPermissionMap[dataset.dataset_share.permission || dataset.community_permission] || {}
            return '<span style=color:' + permission.color + '>' + permission.title + '</span>'
          }
        },
        {
          title: 'Pipeline',
          value: dataset => (datasetPipelineMap[dataset.pipeline] || {}).title
        }
      ] : [
        {
          title: 'Create',
          value: dataset => dateFormat(new Date(dataset.created_at), 'yyyy/MM/dd hh:mm')
        },
        {
          title: 'Modified',
          value: dataset => dateFormat(new Date(dataset.updated_at), 'yyyy/MM/dd hh:mm')
        },
        {
          title: 'Sample size',
          value: dataset => toPriceString(dataset.sample_size)
        },
        {
          title: 'Pipeline',
          value: dataset => (datasetPipelineMap[dataset.pipeline] || {}).title
        },
        {
          title: 'External data',
          value: dataset => dataset.external_data_included ? 'Yes'/* ___ */ : 'No'/* ___ */
        },
        {
          title: 'Status',
          value: dataset => {
            let status = datasetStatusMap[dataset.disabled ? 'disabled' : dataset.state] || {}
            return '<span style=color:' + status.color + '>' + status.title + '</span>'
          }
        }
      ]
    },
    // global
    getCharLength () { return getCharLength },
    subCharString () { return subCharString }
  },
  watch: {
    'dataset.tags.length' () {
      if ((this.$refs['tag-list'] || {}).clientHeight > 24) {
        this.collapse = true
      }
    }
  },
  mounted () {
    if ((this.$refs['tag-list'] || {}).clientHeight > 24) {
      this.collapse = true
    }
  },
  methods: {
    getPictureUrl (file) {
      let config = this.$ls.get('userInfo')
      return file ? file.url || (API_ROOT + 'global/files/download?file_id=' + file.id + '&class_name=' + file.class_name + '&access_token=' + config['access_token']) : ''
    },
    cardOnClick () {
      if (!['default'].includes(this.layoutType)) { return }
      if (!['default'].includes(this.type) && ['private', 'basic'].includes(this.dataset.dataset_share.permission || this.dataset.community_permission) && !['supervisor'].includes(this.user.role)) {
        this.addToast('error', 'You have no permission to open this dataset.'/* ___ */)
        return
      }
      this.$router.push({ name: 'datasetDetail', params: { type: this.type, id: this.dataset.id } })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/dataset/card.vue